import { Chart } from "react-chartjs-2";
import { WellLevelsData, wellLevelsSitesReference } from "../../../types/wellLevelsData";
import { useSitesColors } from "../../SiteColorsProvider/SiteColorsProvider";
import { depthToGroundWaterScale, timeScale } from "../../../types/chart";

export function WellLevelsGraph({ wellLevelsData, sites }: { wellLevelsData: WellLevelsData; sites: string[] }) {
  const siteColors = useSitesColors(sites, "wellLevels");
  const data = {
    datasets: [
      ...sites.map((id) => toLineDataset(wellLevelsData, id as keyof typeof wellLevelsSitesReference, siteColors[id])),
      {
        type: "bar" as const,
        label: "Rainfall",
        data: [
          ...wellLevelsData.records.map((record) => ({ x: new Date(record.date).toISOString(), y: record.rainfall })),
          ...wellLevelsData.rainfall.map(({ date, rainfall }) => ({ x: new Date(date).toISOString(), y: rainfall })),
        ].sort((a, b) => new Date(a.x).getTime() - new Date(b.x).getTime()),
        backgroundColor: "cyan",
        yAxisID: "rainfall",
        barThickness: 2,
      },
    ],
  };
  return <Chart type="bar" options={options()} data={data} />;
}

function toLineDataset(wellLevelsData: WellLevelsData, id: keyof typeof wellLevelsSitesReference, color: string) {
  return {
    type: "line" as const,
    label: wellLevelsSitesReference[id].label,
    data: [
      ...wellLevelsData.records.map((record) => ({ x: new Date(record.date).toISOString(), y: record[id] })),
      ...wellLevelsData.scadaRecords
        .filter((record) => record.wellName === id.toUpperCase())
        .filter((record) => record.pumpStatus === "Stopped")
        .map((record) => ({ x: record.date.toISOString(), y: record.waterLevelFT })),
    ].sort((a, b) => new Date(a.x).getTime() - new Date(b.x).getTime()),
    backgroundColor: color,
    borderColor: color,
    yAxisID: "depthToGroundWater",
    pointRadius: 2,
  };
}

export const options = () => ({
  responsive: true,
  scales: {
    x: timeScale,
    rainfall: {
      ticks: {
        callback: function (value: string | number, index: number, ticks: any) {
          return `${value}"`;
        },
      },
      title: { display: true, text: "Rainfall (in)", font: { size: 20 } },
      position: "right" as const,
    },
    depthToGroundWater: depthToGroundWaterScale,
  },
  spanGaps: true,
  plugins: {
    title: {
      display: true,
      text: "Groundwater Levels and Rainfall",
    },
  },
});
